class Search
{
  constructor( { data, max_results = 6, results_selector = false, search_selector, results_attr = 'searchresult', no_results_msg = 'no results found', callback } = {} )
  {
    this.results_selector = results_selector;
    this.search_selector = search_selector;
    this.search_results_nodes = [];
    this.max_search_results = max_results;
    this.result_index = 0;
    this.data = data;
    this.results_attr = results_attr;
    this.no_results_msg = no_results_msg;
    this.callback = callback;
    this.create_search_result_nodes();
    this.add_events();
    this.previous_result;
  }

  add_events()
  {
    const self = this;
    this.events = new EventDelegator( [
    {
      selector: '#js-app',
      eventType: 'click',
      events:
      {
        app: ( e, d ) =>
        {
          self.close_search();
        },

        [ this.results_attr ]: ( e, d ) =>
        {
          self.open_section_from_dropdown( get_node_index( self.search_results_nodes, e.target ) );
        },

        go: ( e, d ) =>
        {
          self.open_section_from_dropdown( this.result_index );
        },
      }
    },
    {
      selector: this.search_selector,
      eventType: 'keyup',
      events:
      {
        search: ( e, d ) =>
        {
          self.search( e );
          e.stopPropagation();
        }
      }
    },
    {
      selector: this.search_selector,
      eventType: 'keydown',
      events:
      {
        search: self.supress_ke()
      }
    },
    {
      selector: this.results_selector,
      eventType: 'mouseover',
      events:
      {
        [ this.results_attr ]: ( e, d ) =>
        {
          e.stopPropagation();
          self.search_result_mousover( e.target );
        }
      }
    } ] );


  }

  /**
   * @method create_search_result_nodes - creates the results nodes which will be added to the results dropdown
   */
  create_search_result_nodes()
  {
    for ( let i = 0; i < this.max_search_results; i++ )
    {
      this.search_results_nodes.push( new Element( { classes: [ 'search-result' ], attributions: { attribute: `data-${this.results_attr}` } } ).returnElement() );
    }
  }

  /**
   * @method search - delegates depending on the key press
   * @param {Object} e - event object
   */
  search( e )
  {
    const value = e.target.value;
    const key = e.which;

    key === 40 // down
      ? this.navigate_results( 'down' )
      : ( key === 38 ) // up
      ? this.navigate_results( 'up' )
      : ( key === 13 ) // enter
      ? this.open_section_from_dropdown( this.result_index )
      : ( key !== 37 && key !== 39 ) // not left / right keys
      ? this.update_search_results( filter_by_function( this.data, ( obj ) =>
      {
        return this.match_search_value( obj, value ) ? obj : false
      } ), value )
      : false;
  }

  /**
   * @function match_search_value - checks if obj.text includes the input value
   * @param {Object} obj - object from d array
   * @param {String} value - user input
   */
  match_search_value( obj, value )
  {
    value = sanatise_string( value );
    let text = sanatise_string( obj.text );
    return !validate_string( value ) ? false : text.includes( value );
  };

  /**
   * @function update_search_results - delegates updating results
   * @param {Array} results - filtered array of objects
   * @param {String} value - user input
   */
  update_search_results( results, value )
  {

    // add default message if no results are found
    results = this.is_empty_results_msg_required(results, value);

    const results_dropdown = cached_elements.get_node( this.results_selector );

    const results_added = this.add_search_results( results_dropdown, results, value );

    results_added
      ? results_dropdown.classList.add( 'active' )
      : results_dropdown.classList.remove( 'active' );
  };

  /**
   * @function add_search_results - adds new results to results dropdown
   * @param {Node} results_dropdown
   * @param {Array} results - filtered array of objects
   * @param {String} value - user input
   */
  add_search_results( results_dropdown, results, value )
  {
    let top_results;
    let required_search_nodes;
    let results_added = false;

    remove_children( results_dropdown );

    if ( results.length )
    {
      top_results = this.get_top_results( results, value );
      required_search_nodes = this.search_results_nodes.slice( 0, top_results.length );

      this.update_results( required_search_nodes, top_results, value );
      append_children( results_dropdown, required_search_nodes );
      this.update_active_result( 0, true );
      results_added = true;
    }
    return results_added;
  }

  /**
   * @function get_top_results - returns new array with top x results to display in the dropdown
   * @param {Array} results - filtered array of objects
   * @param {String} value - user input
   */
  get_top_results( results, value )
  {
    return results.sort( ( a, b ) =>
    {
      return a.text.indexOf( value ) - b.text.indexOf( value );
    } ).splice( 0, this.max_search_results );
  };

  /**
   * @function update_results - updates the results node innerHTML and data attribute
   * @param {Array} nodes_array - array of nodes to update
   * @param {Array} results_array - filtered results array
   * @param {String} value - user input
   */
  update_results( nodes_array, results_array, value )
  {
    nodes_array.forEach( ( node, i ) =>
    {
      node.innerHTML = this.highlight_matching_value( results_array[ i ].text, value );
      node.setAttribute( `data-${this.results_attr}`, results_array[ i ].links_to );
    } );
  };

  /**
   * @function highlight_matching_value - wraps the matching part of the result string with a span.class
   * @param {String} string - result string
   * @param {String} value - user input
   * @param {String} cl - class to wrap the matching part of the string with
   */
  highlight_matching_value( string, value, cl = 'bold' )
  {
    value = sanatise_string( value );
    const regex = new RegExp( `=?(${value})` );
    return sanatise_string( string ).replace( regex, `<span class="${cl}" data-mute>${value}</span>` );
  };

  /**
   * @function close_search - resets the serach input and results dropdown
   */
  close_search()
  {
    const parent = cached_elements.get_node( this.results_selector );
    const input = cached_elements.get_node( `${this.search_selector} [data-search]` );
    remove_children( parent );
    input.value = '';

  }

  /**
   * @function open_section_from_dropdown(  - opens the required section of the app
   * @param {Number} index - result index
   */
  open_section_from_dropdown( index )
  {
    const result_dropdown = cached_elements.get_node( this.results_selector ).children;
    const node = result_dropdown[ index ];

    if ( node && this.callback )
    {
      const section = node.getAttribute( `data-${this.results_attr}` );

      if ( section !== 'null')
      {
        console.log(section)
        this.callback( section, node );
      }

      this.close_search();
    }
  }

    /**
   * @function is_empty_results_msg_required  - delegates get_active_result_index and update_active_result
   * @param {Array} results - array of objects
   * @param {String} value - user input
   */
  is_empty_results_msg_required( results, value )
  {
    return !results.length && value.length ? [ { text: this.no_results_msg, links_to: null } ] : results;
  }

  /**
   * @function navigate_results  - delegates get_active_result_index and update_active_result
   * @param {String} direction - up / down
   */
  navigate_results( direction )
  {
    const result_index = this.get_active_result_index( direction );
    this.update_active_result( result_index );
    cached_elements.get_node( this.results_selector ).classList.add( 'keys' );
  }

  /**
   * @function get_active_result_index  - Keeps track of the active result index
   * @param {String} direction - up / down
   */
  get_active_result_index( direction )
  {
    const num_results = cached_elements.get_node( this.results_selector ).children.length;
    const self = this;
    return direction === 'up'
      ? self.result_index === 0 ? num_results - 1 : self.result_index - 1
      : direction === 'down'
      ? self.result_index < num_results - 1 ? self.result_index + 1 : 0
      : false;
  };

  /**
   * @function update_active_result  - Handles moving the active class up / down the results
   */
  update_active_result( index, reset_index = false )
  {
    const results = cached_elements.get_node( this.results_selector ).children;
    if ( this.previous_result )
    {
      this.previous_result.classList.remove( 'active' );
    }
    results[ index ].classList.add( 'active' );
    this.previous_result = results[ index ];
    this.result_index = index;

    this.reset_results_index( reset_index );
    return results[ index ];
  }

  /**
   * @function reset_results_index  - resets results index
   * @param {Boolean} reset_index
   */
  reset_results_index( reset_index )
  {
    if ( reset_index )
    {
      this.result_index = 0;
    }
  }

  /**
   * @function search_result_mousover  - delegates
   * @param {Node} result - node that has been hovered over
   */
  search_result_mousover( result )
  {
    this.update_active_result( get_node_index( this.search_results_nodes, result ) );
    cached_elements.get_node( this.results_selector ).classList.remove( 'keys' );
  }

  /**
   * @function supress_key_behaviour
   * @param {Object} e - event object
   * @param {Object} d - data attribute object
   */
  supress_ke()
  {
    return ( e, d ) =>
    {
      e = e || window.event;
      const key = e.which;
      if ( key == 38 )
      {
        e.preventDefault();
        return false;
      }
    }
  }
}


const hub_search = new Search( { data: d, results_selector: '#js-search-results', search_selector: '#js-search', callback: open_section, no_results_msg: 'Your search doesn’t match our predetermined results…...' } );